const LK_Add =({color,width,height})=>{
    return(
        <svg id="Layer_1" fill={color} data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 116.99 116.99">
            {/* <defs>
                    <style>
                    .cls-1 {
                        fill: #005c8e;
                        stroke-width: 0px;
                    }
                    </style>
                </defs> */}
            <path class="cls-1" d="M58.49,4.34c29.86,0,54.16,24.29,54.16,54.16s-24.29,54.16-54.16,54.16S4.34,88.35,4.34,58.49,28.63,4.34,58.49,4.34M58.49,0C26.19,0,0,26.19,0,58.49s26.19,58.49,58.49,58.49,58.49-26.19,58.49-58.49S90.8,0,58.49,0h0Z"/>
            <path class="cls-1" d="M60.66,22.35v33.97h33.97v4.34h-33.97v33.97h-4.34v-33.97H22.35v-4.34h33.97V22.35h4.34M65,18.01h-13.01v33.97H18.01v13.01h33.97v33.97h13.01v-33.97h33.97v-13.01h-33.97V18.01h0Z"/>
        </svg>
    );
};

export default LK_Add;